import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import InputMask from 'react-input-mask';
import { FormFeedback } from 'reactstrap';

import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import CurrencyInput from "../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import { formatCurrency } from './../functions/dateFunctions.js'

import { getCotizacionDolar } from "./../../api/calls.js"

import 'react-datepicker/dist/react-datepicker.css';

const parseMontoFloat = (x) => (parseFloat(((x.toString()).replace(/[.]/g, '')).replace(',', '.')));

class ModalCotizacionDolar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaCotizacion: moment(),
            monto: '0,00',
            cotizacion_dolar_oficial: '0,00',
            cotizacion_dolar_mep: '0,00',
            monto_dolar_oficial: '0,00',
            monto_dolar_mep: '0,00',

            errors: {},
            errorsIgnorables: {}, // Errores que se muestran pero aun asi se permiten guardar los datos.

            loadingCotizacionDolar: false,
            isCotizacionDolarLoaded: false, // Para poder cargar la cotizacion del dolar cada vez que se abra el modal (solo en create)
            selectedFacturaChanged: false,
        };
    }

    static propTypes = {
        id: PropTypes.func,
        tableData: PropTypes.object,
    }

    componentDidUpdate(prevProps, prevState) {
        const { id, tableData } = this.props;
        const parametersExist = id && id() && tableData && tableData.length > 0;
        const parametersChanged = prevProps.id !== id || prevState.isCotizacionDolarLoaded !== this.state.isCotizacionDolarLoaded;

        if (parametersExist && parametersChanged){
            const pk = id();
            const selectedFactura = tableData.find(factura => factura.pk === pk);

            this.setState({
                fechaCotizacion: moment(selectedFactura.fechaDeFacturacion),
                monto: selectedFactura.monto,
            },
                () =>  this.updateCotizacionesEnDolares()
            )

        } else if(prevProps.id !== id) {
            // Caso en que no se selecciono una factura
            this.resetState();
        } else if(prevState.isCotizacionDolarLoaded !== this.state.isCotizacionDolarLoaded) {
            this.updateCotizacionesEnDolares();
        }
    }

    componentDidMount(){
        this.updateCotizacionesEnDolares()
    }

    updateMontosEnDolares = () => {
        const { monto, cotizacion_dolar_oficial, cotizacion_dolar_mep } = this.state;

        // Se convierte el string con numero en español a formato inglés del float
        const formattedMonto = monto ? parseMontoFloat(monto) : 0;
        const formattedCotizacionOficial = cotizacion_dolar_oficial ? parseMontoFloat(cotizacion_dolar_oficial) : 0;
        const formattedCotizacionMep = cotizacion_dolar_mep ? parseMontoFloat(cotizacion_dolar_mep) : 0;

        // Y nuevamente se pasa de formato inglés del float a string con numero español
        this.setState({
            monto_dolar_oficial: formatCurrency(formattedCotizacionOficial > 0 ? formattedMonto / formattedCotizacionOficial : 0),
            monto_dolar_mep: formatCurrency(formattedCotizacionMep > 0 ? formattedMonto / formattedCotizacionMep : 0),
        });
    }

    updateCotizacionesEnDolares = () => {
        // Hay que asegurarse de que el state se actualize primero y despues avanzar con el resto
        this.setState({
            loadingCotizacionDolar: true,
        },
            () => {
                const { fechaCotizacion, errorsIgnorables } = this.state;
                // Se limpia el mensaje de error
                let resetedFechaDeCobroErrorsIgnorables = { ...errorsIgnorables };
                delete resetedFechaDeCobroErrorsIgnorables.fechaCotizacion;

                getCotizacionDolar(fechaCotizacion).then((response) => {
                    let dolarOficial = '0,00';
                    let dolarMep = '0,00';
                    let newErrorsIgnorables = { ...resetedFechaDeCobroErrorsIgnorables};

                    if (response.success) {
                        const dolar = response.data;
                        dolarOficial = dolar.oficial.valor_venta_pesos_argentinos;
                        dolarMep = dolar.mep.valor_venta_pesos_argentinos;
                    } else {
                        newErrorsIgnorables = { ...newErrorsIgnorables, ...response.errors };
                    }

                    this.setState({
                        cotizacion_dolar_oficial: formatCurrency(dolarOficial),
                        cotizacion_dolar_mep: formatCurrency(dolarMep),

                        errorsIgnorables: newErrorsIgnorables,

                        loadingCotizacionDolar: false,
                        isCotizacionDolarLoaded: true,
                    },
                        () => this.updateMontosEnDolares()
                    );
                })
            }
        )

    }

    resetState = () => {
        this.setState({
            fechaCotizacion: moment(),
            monto: '0,00',
            cotizacion_dolar_oficial: '0,00',
            cotizacion_dolar_mep: '0,00',
            monto_dolar_oficial: '0,00',
            monto_dolar_mep: '0,00',
            insumosDirectos: '0,00',

            errors: {},
            errorsIgnorables: {},

            loadingCotizacionDolar: false,
            isCotizacionDolarLoaded: false,
        })
    }

    onFechaDeCobroChange = (fechaCotizacion) =>{

        this.setState({
            fechaCotizacion: fechaCotizacion,
        },
            () => this.updateCotizacionesEnDolares()
        )
    }

    onMontoChange = (data) => {
        this.setState({
            monto: data,
        },
            // Se asegura que monto ya se seteo (por ser async setState)
            () => this.updateMontosEnDolares()
        );
    }

    renderCurrencyInput = ({ value, onChange, disabled = false }) => (
        <CurrencyInput
            placeholder='0'
            className='monto'
            selectOnFocus={true}
            maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }}
            disabled={disabled}
            value={value}
            onChange={onChange}
            onBlur={!disabled ? () => this.setState({ monto: (this.state.monto != null && this.state.monto != '') ? (this.state.monto) : ('0') }) : undefined}
        />
    )

    render() {
        const {
            fechaCotizacion,
            monto,
            cotizacion_dolar_oficial,
            cotizacion_dolar_mep,
            monto_dolar_oficial,
            monto_dolar_mep,
            errors,
            errorsIgnorables,
            loadingCotizacionDolar,
        } = this.state;

        return (
            <ParadigmaModal 
                title= "Cotización del Dólar"
                buttonTitle="Ver Cotización del Dólar"
                buttonIcon="fa fa-usd fa-lg"
                onClose={() => this.resetState() & (this.props.onClose && this.props.onClose())}
                disabled={false}
                closeButton={true}
                className="ui-modal-dialog ui-modal-md"
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Datos de consulta</h5>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <label>Fecha de cotización</label>
                                <DatePicker
                                    selected={fechaCotizacion}
                                    onChange={this.onFechaDeCobroChange}
                                    timeFormat=""
                                    className="form-control"
                                    timeIntervals={15}
                                    dateFormat="DD/MM/YYYY"
                                    timeCaption="time"
                                    customInput={<InputMask name="fechaCotizacion" className="form-control" mask="99/99/9999" type="text" />}
                                />
                                {!loadingCotizacionDolar &&
                                    <FormFeedback className={(errorsIgnorables.fechaCotizacion != undefined ? "d-block" : "")}>{errorsIgnorables.fechaCotizacion}</FormFeedback>
                                }
                            </div>
                            <div className="ui-field">
                                <label>Monto ($)</label>
                                {this.renderCurrencyInput({
                                    value: monto,
                                    onChange: this.onMontoChange,
                                })}
                                <FormFeedback className={(errors.monto != undefined ? "d-block" : "")}>{errors.monto}</FormFeedback>
                            </div>
                        </div>
                        {loadingCotizacionDolar &&
                            <div className="ui-alert ui-alert-info">Recuperando cotización del dólar...</div>
                        }
                    </section>

                    <section className="ui-section-block mt-3">
                        <h5 className="ui-section-label">Cotizaciones</h5>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <label>Cotización dólar oficial ($)</label>
                                {this.renderCurrencyInput({
                                    value: cotizacion_dolar_oficial,
                                    disabled: true,
                                })}
                            </div>
                            <div className="ui-field">
                                <label>Cotización dólar MEP ($)</label>
                                {this.renderCurrencyInput({
                                    value: cotizacion_dolar_mep,
                                    disabled: true,
                                })}
                            </div>
                        </div>
                    </section>

                    <section className="ui-section-block mt-3">
                        <h5 className="ui-section-label">Montos equivalentes</h5>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <label>Monto en dólar oficial (U$S)</label>
                                {this.renderCurrencyInput({
                                    value: monto_dolar_oficial,
                                    disabled: true,
                                })}
                            </div>
                            <div className="ui-field">
                                <label>Monto en dólar MEP (U$S)</label>
                                {this.renderCurrencyInput({
                                    value: monto_dolar_mep,
                                    disabled: true,
                                })}
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal >
        );
    }
}

export default ModalCotizacionDolar;



// WEBPACK FOOTER //
// ./src/views/Indicadores/ModalCotizacionDolar.js